module.exports = __webpack_public_path__ + "img/sectionuparrow.800857a7.svg";